import { useQuerySubscription } from "react-datocms"
import { getAllRecords, getSubscription, queries, request } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import { datoModels } from "@data/static"
import NotFound from "@components/static/NotFound/NotFound"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"
// import PartyDataWrapper from "@components/party/PartyDataWrapper/PartyDataWrapper.js"
import SupplierDetails from "@components/supplier/SupplierDetails/SupplierDetails"
import emptySearchDesktop from "@images/pages/banners/emptySearchDesktop.jpg"
import emptySearchMobile from "@images/pages/banners/emptySearchMobile.jpg"

export default function Supplier({ subscription, options }) {
  if (!subscription) {
    return (
      <Layout options={options}>
        <Seo title="404: Not found" />
        <NotFound />
      </Layout>
    )
  }
  const {
    data: { seo, supplier, featuredBlogs, similarSuppliers },
  } = useQuerySubscription(subscription)

  const emptySuppliers = {
    backgroundImage: {
      mobile: emptySearchMobile,
      desktop: emptySearchDesktop,
    },
    title: "Search our black book",
    text: "Find premium and trustworthy suppliers for all your party needs",
    btnLabel: "Browse",
  }

  return (
    <Layout options={options} enableLock>
      <Seo global={seo} meta={supplier.seo} />
      <SupplierDetails
        supplier={supplier}
        featuredBlogs={featuredBlogs}
        similarSuppliers={similarSuppliers}
        emptySuppliers={emptySuppliers}
      />
    </Layout>
  )
}

export async function getStaticPaths() {
  const { records } = await getAllRecords(datoModels.SUPPLIER, null, null, true)
  return {
    paths: records.map((supplier) => `/supplier/${supplier.slug}`),
    fallback: "blocking",
  }
}

export async function getStaticProps({ params }) {
  const data = await request({ query: `{ supplier(filter: {slug: {eq: "${params.slug}"}}) { id } }` })
  const graphqlRequest = data.supplier?.id
    ? {
        query: `
      query SupplierPage($slug: String) {
        ${queries.seo}
        supplier(filter: {slug: {eq: $slug}}) {
          ${queries.innerSupplier}
        }
        featuredBlogs: allBlogs(orderBy: publishedDate_DESC, first: 3, filter: {featuredSuppliers: {anyIn: "${
          data.supplier.id
        }"}}) {
         ${queries.blog.query}
        }
        similarSuppliers: allSuppliers(filter: {slug: {neq: $slug}}, orderBy: rank_DESC, first: 4, skip: ${Math.floor(
          Math.random() * 18
        )}) {
          ${queries.supplier.query}
        }
      }
    `,
        variables: {
          slug: params.slug,
        },
      }
    : null

  const subscription = graphqlRequest ? await getSubscription(graphqlRequest) : null
  const options = await loadOptionsData()

  return {
    props: {
      key: data.supplier?.id || "404",
      subscription,
      options,
    },
  }
}
